import List from "../../containers/CruiselinePage/List";
import Entry from "../../containers/CruiselinePage";

const cruiselinePageRoutes = [
  {
    path: "/cruiseline-page",
    exact: true,
    auth: true,
    component: List
  },
  {
    path: "/cruiseline-page/:type",
    exact: true,
    auth: true,
    component: Entry
  },
  {
    path: "/cruiseline-page/:type/:id",
    exact: true,
    auth: true,
    component: Entry
  }
];

export default cruiselinePageRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/cruiselinePage.jsx